import {navigateTo} from '@typed-router';
import {defineNuxtRouteMiddleware} from '#app';
import {useAdvancedSearchStore} from '~/features/advanced-search/stores/advancedSearch.store';

export default defineNuxtRouteMiddleware(() => {
    const {advancedSearch} = useAdvancedSearchStore();

    if (!advancedSearch) {
        return navigateTo('/project-client/find-freelancers', {external: true});
    }
});
